angular.module('app.services').service('phasesService', function ($translate, DataTablesFactory, variables, api) {
    const Service = this;

    Service._model = api('phase');

    Service.getAll = () => {
        return Service._model.list().then((response) => response.data);
    };

    Service.getFiltered = (values) => {
        const params = {
            data: {
                filter: values,
            },
        };

        return Service._model.filter(params).then((response) => {
            // tłumaczenie typów projektów
            response.data.stats.type = _.map(response.data.stats.type, (row) => {
                row.value = $translate.instant(`projects.${row.value}`);

                return row;
            });

            // statystyki
            const stats = DataTablesFactory.prepareStats(response.data.stats, {
                fields: ['status_id', 'type', 'service_work_id', 'service_type_id', 'transport_type_id', 'packaging_method_id'],
                callback(stats) {
                    // colors
                    const types = ['measurement', 'installation', 'transport', 'service'];
                    stats.fields['type'].colors = _.map(stats.fields['type'].data, (row) => {
                        const map = {};
                        angular.forEach(types, (type) => {
                            map[$translate.instant(`projects.${type}`)] = variables.colors[type];
                        });

                        return map[row.value] || variables.colors.primary;
                    });

                    return stats;
                },
            });

            return {
                list: response.data.data,
                stats,
            };
        });
    };

    Service.selectize = () =>
        Service._model
            .selectize({
                transform: {
                    id: 'id',
                    value: ':name',
                },
            })
            .then((response) => _.sortBy(response.data, 'label'));

    Service.find = (id) => Service._model.get(id).then((response) => response.data);

    Service.save = (group) => Service._model.post(group);
});
